import { render, staticRenderFns } from "./Logistic.vue?vue&type=template&id=5e621ac8&scoped=true"
import script from "./Logistic.vue?vue&type=script&lang=js"
export * from "./Logistic.vue?vue&type=script&lang=js"
import style0 from "./Logistic.vue?vue&type=style&index=0&id=5e621ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e621ac8",
  null
  
)

export default component.exports